// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as CountComponent} from './Count.svg';

import Icon, { TIconProps } from '../Icon';

export const IconCount = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <CountComponent/>
  </Icon>
));
